import { render } from "./LatestMusic.vue?vue&type=template&id=46701121&scoped=true"
import script from "./LatestMusic.vue?vue&type=script&lang=js"
export * from "./LatestMusic.vue?vue&type=script&lang=js"

import "./LatestMusic.vue?vue&type=style&index=0&id=46701121&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46701121"]])

export default __exports__